import Auth from "@/services/auth.js";

export default {
  links: {
    //beepiz
    beepiz: process.env.HUB_URL_BPZ || 'ENV_NULL',
    sfrBeepiz: process.env.HUB_URL_BPZ_SFR || 'ENV_NULL',
    catsafeBeepiz: process.env.HUB_URL_BPZ_CATSAFE || 'ENV_NULL',

    //manager
    manager: process.env.HUB_URL_MANAGER || 'ENV_NULL',
    sfrManager: process.env.HUB_URL_MANAGER_SFR || 'ENV_NULL',
    catsafeManager: process.env.HUB_URL_MANAGER_CATSAFE || 'ENV_NULL',

    //support
    support: process.env.HUB_URL_SUPPORT || 'ENV_NULL',
    sfrSupport: process.env.HUB_URL_SUPPORT_SFR || 'ENV_NULL',
    catsafeSupport: process.env.HUB_URL_SUPPORT_CATSAFE || 'ENV_NULL',
  },
  getLink(universe) {
    return this.links[universe]
      .replace("{token}", Auth.accessToken)
      .replace("{key}", Auth.key)
      .replace("{from}", window.location.href)
      .replace("{lang}", window.V.$localStorage.get("bpz_lang") || "fr")
      .replace("{refresh}", Auth.refresh_token || window.V.$localStorage.get("REFRESH_TOKEN"));
  },
};
